module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Propriedades - Contatos")]), _c('div', {
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Crie campos personalizados para serem utilizados em seus contatos.")]), _c('br'), _c('br'), _c('new-custom-fields-modal', {
    attrs: {
      "edit_custom_field": _vm.edit_custom_field
    },
    on: {
      "close-create-modal": _vm.closeCreateModal,
      "custom-field-created": _vm.created,
      "custom-field-updated": _vm.updated
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showCreateModal
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v("Nova propriedade")]), _c('list', {
    ref: "list",
    on: {
      "edit": _vm.edit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a44c42e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/custom_fields/index.vue
// module id = 1081
// module chunks = 1